export { useSliders, type UseSlidersOptions } from "@/hooks/slider/useSliders";

